module.exports = __webpack_public_path__ + "img/slider-02.0952f4a7.jpg";